<template>
    <div>
      <el-card class="box-card">
        <el-form :model="editForm" ref="editFormRef" label-width="170px">
          <el-form-item class="addAdminForm" label="所属团队">
            <el-select v-model="editForm.teamid" placeholder="请选择" class="select" filterable>
              <el-option label="无团队" value="0"></el-option>
              <el-option
                v-for="item in TeamList" :key="item.Id" :label="item.Teamname" :value="item.Id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="addAdminForm" label="销售人员姓名">
            <el-input v-model="editForm.manname"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="身份证号">
            <el-input v-model="editForm.sfcard"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="联系方式">
            <el-input v-model="editForm.lianxifangshi"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="业绩要求">
            <el-input v-model="editForm.yejiyaoqiu"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="提成比例或方案">
            <el-input v-model="editForm.tichengbili"></el-input>
          </el-form-item>
          <el-form-item class="addAdminForm" label="备注">
            <el-input v-model="editForm.beizhu"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clicksave">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  data () {
    return {
      TeamList:[],
      editForm: {
        id: 0,
        teamid: '',
        manname: '',
        sfcard: '',
        lianxifangshi: '',
        yejiyaoqiu: '',
        tichengbili: '',
        beizhu: ''
      }
    }
  },
  mounted () {
    this.apiGetErp6SaleBaseSalesTeamListAll()
  },
  methods: {
    LoadData (row) {
      this.editForm.id = row.Id
      this.editForm.teamid = row.Teamid
      if(row.Teamid == 0 ){
        this.editForm.teamid = "0"
      }
      this.editForm.manname = row.Manname
      this.editForm.sfcard = row.Sfcard
      this.editForm.lianxifangshi = row.Lianxifangshi
      this.editForm.yejiyaoqiu = row.Yejiyaoqiu
      this.editForm.tichengbili = row.Tichengbili
      this.editForm.beizhu = row.Beizhu
    },
    clickreturn () {
      this.$emit('triggerFunc', '')
    },
    clicksave () {
      this.apiEditErp6SaleBaseSalesperson()
    },
    apiGetErp6SaleBaseSalesTeamListAll: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetErp6SaleBaseSalesTeamListAll, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.TeamList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiEditErp6SaleBaseSalesperson: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      data = { ...data, ...that.editForm }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditErp6SaleBaseSalesperson, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 365px;
}
</style>
